"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NightsPickerRangeDesktop = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SearchSelect = require("../../SearchSelect");
var _NightsCounter = require("./NightsCounter");
var _pluralizeUtils = require("../../../utils/pluralizeUtils");
var NightsPickerRangeDesktop = exports.NightsPickerRangeDesktop = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var startNight = _ref.startNight,
    endNight = _ref.endNight,
    onChangeStartNight = _ref.onChangeStartNight,
    onChangeEndNight = _ref.onChangeEndNight,
    _ref$minValue = _ref.minValue,
    minValue = _ref$minValue === void 0 ? 2 : _ref$minValue,
    _ref$maxValue = _ref.maxValue,
    maxValue = _ref$maxValue === void 0 ? 30 : _ref$maxValue;
  var nights = startNight === endNight ? endNight : "".concat(startNight, "-").concat(endNight);
  var handleChangeStartNight = function handleChangeStartNight(val) {
    onChangeStartNight(val);
    if (val >= endNight) {
      onChangeEndNight(val + 1);
    }
  };
  var handleChangeEndtNight = function handleChangeEndtNight(val) {
    onChangeEndNight(val);
    if (val <= startNight) {
      onChangeStartNight(val - 1);
    }
  };
  var CustomOption = function CustomOption() {
    return /*#__PURE__*/_react["default"].createElement(CounterWrapper, null, "\u041E\u0442", /*#__PURE__*/_react["default"].createElement(_NightsCounter.NightsCounter, {
      value: startNight,
      onValueChange: handleChangeStartNight,
      minValue: minValue,
      maxValue: maxValue
    }), "\u0434\u043E", /*#__PURE__*/_react["default"].createElement(_NightsCounter.NightsCounter, {
      value: endNight,
      onValueChange: handleChangeEndtNight,
      minValue: minValue + 1,
      maxValue: maxValue - 1
    }), "\u043D\u043E\u0447\u0435\u0439");
  };
  var Option = {
    custom: true,
    CustomComponent: CustomOption
  };
  var SingleValue = function SingleValue(props) {
    var innerProps = props.innerProps,
      selectProps = props.selectProps;
    var menuIsOpen = selectProps.menuIsOpen;
    return /*#__PURE__*/_react["default"].createElement(StyledLabel, (0, _extends2["default"])({}, innerProps, {
      menuIsOpen: menuIsOpen
    }), "".concat(nights, " ").concat((0, _pluralizeUtils.pluralizeNights)(nights)));
  };
  var customStyles = {
    menu: function menu() {
      return {
        width: 280
      };
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_SearchSelect.SearchSelect, {
    CustomSingleValue: SingleValue,
    options: [Option],
    customStyles: customStyles,
    isSearchable: false,
    isClearable: false,
    closeMenuOnSelect: false,
    captureMenuScroll: false,
    menuShouldBlockScroll: false
  });
});
NightsPickerRangeDesktop.displayName = 'NightsPickerRange';
var StyledLabel = _styledComponents["default"].div.withConfig({
  displayName: "NightsPickerRangedesktop__StyledLabel",
  componentId: "sc-1wue6y8-0"
})(["display:flex;align-items:center;font-size:16px;line-height:20px;font-weight:500;color:", ";"], function (_ref2) {
  var menuIsOpen = _ref2.menuIsOpen,
    theme = _ref2.theme;
  return menuIsOpen ? theme.colors.lightGrey : theme.colors.blackBase;
});
var CounterWrapper = _styledComponents["default"].div.withConfig({
  displayName: "NightsPickerRangedesktop__CounterWrapper",
  componentId: "sc-1wue6y8-1"
})(["display:flex;align-items:center;justify-content:center;padding:0 8px;"]);